import React from 'react'
import Image from 'next/image'
import Text from 'app/app/(client)/components/atoms/Text/Text'
import { Constants } from 'app/app/(client)/utils/client-constants'

interface NoDataProps {
  iHeight?: number
  iWidth?: number
  noDataText: string
  children?: React.ReactNode
}

const NoData: React.FC<NoDataProps> = ({ noDataText, children, iHeight = 400, iWidth = 473 }) => (
  <div className="flex flex-col justify-center items-center mt-6">
    <Image src={Constants.NO_DATA_IMAGE} alt="No Data" width={iWidth} height={iHeight} />

    <Text id="no-shared-opportunity-text" as="div" className="text-center text-grey-outline text-16px font-normal mt-5">
      {noDataText}
    </Text>
    {children && <div className="mt-6">{children}</div>}
  </div>
)

export default NoData
